/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { loading } from 'hocs/loading'
import { onStartLogout } from 'redux-app/actionCreators/auth'
import { onShowError } from 'redux-app/modules/alerts'
import { checkChangePasswordLink } from 'api/client/actions/auth'
import { isUserAuthorizated } from 'redux-app/selectors/auth'
import { getQueryFromSearch } from 'utils/location'
import { STEPS } from './constants'
import ChangePasswordCheckLink from './ChangePasswordCheckLink'

export default compose(
  connect(
    state => ({
      isUserAuthorizated: isUserAuthorizated(state),
    }),
    {
      checkChangePasswordLink,
      onStartLogout,
      onShowError,
    },
  ),
  withRouter,
  lifecycle<any, any>({
    componentDidMount () {
      const {
        history: { replace },
        location: { search },
        onStartLogout,
        isUserAuthorizated,
      } = this.props
      const { token } = getQueryFromSearch(search)

      isUserAuthorizated && onStartLogout()

      if (!token) {
        replace(ROUTES.auth.login)
        return
      }

      this.setState({
        loadProgress: 100,
        step: STEPS.valid,
      })
      return
    },
  }),
  loading,
  withLocalization('auth.changePassword.checkLink'),
)(ChangePasswordCheckLink)
